import { merge } from 'lodash';

import types from './typeDefs';
import mutations from './mutations';
// import queries from './queries';

export const typeDefs = [...types];

export const resolvers = merge({}, mutations);
